import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../../components/footer/footer.component';
import { CommonHeaderComponent } from '../../../../components/common-header/common-header.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'covid19',
  standalone: true,
  imports: [FooterComponent, CommonHeaderComponent, CommonModule],
  templateUrl: './covid19.component.html',
  styleUrl: './covid19.component.scss',
})
export class Covid19Component {
  constructor(
    private sanitizer: DomSanitizer,
    private titleService: Title,
    private metaService: Meta,
  ) {}
  pageContent: SafeHtml = '';
  pageTitleImg: string = '';
  pageHead: string = 'COVID-19';

  ngOnInit() {
    this.titleService.setTitle('COVID-19');
    this.metaService.updateTag({
      property: 'og:title',
      content: 'COVID-19',
    });
    this.pageTitleImg = 'assets/images/w2c/page-header/faqs.jpg';
  }
}
